'use strict';

angular.module('systemOwnerReviewControllers.ReviewUniquePermissions')

    .controller('UniquePermissionsBySystemTypeController', ['$scope', '$state', '$modal', 'reviewUniquePermissionsService', 'nextProcessStep', 'systemType', 'systemTypesToReview', 'systemRolesToReview', function ($scope, $state, $modal, reviewUniquePermissionsService, nextProcessStep, systemType, systemTypesToReview, systemRolesToReview) {
        $scope.systemType = systemType;

        $scope.systemTypesToReview = systemTypesToReview;
        $scope.systemsAndRoles = systemRolesToReview;
        $scope.withSystems = $scope.systemsAndRoles.length > 0;
        $scope.isProcessing = false;
        $scope.systemListIsCollapsed = false;

        var SYSTEM_ROLE_COLLAPSED_TRESHOLD = 60;

        var sysRoleEmployeesCount = _.reduce($scope.systemsAndRoles, function (total, system) {
            var countBySystem = _.reduce(system.SystemRoles, function (totalBySystem, sysRole) {
                return totalBySystem + sysRole.SystemRoleEmployees.length;
            }, 0);

            return total + countBySystem;
        }, 0);

        $scope.ctrlCtxt = {};
        if (sysRoleEmployeesCount > SYSTEM_ROLE_COLLAPSED_TRESHOLD) {
            $scope.systemListIsCollapsed = true;
            $scope.ctrlCtxt.showCollapsed = true;
            $scope.ctrlCtxt.onlyDisplaySystemIdx = 0;
        }

        // Show Permissions For System Index
        $scope.showPermissionsForSystemIndex = function (index) {
            $scope.ctrlCtxt.onlyDisplaySystemIdx = index;
        }

        // Show Permissions For System Index
        $scope.hidePermissionsForSystem = function () {
            $scope.ctrlCtxt.onlyDisplaySystemIdx = null;
        }

        // Read only ?
        $scope.isReadOnly = !nextProcessStep.IsReviewUniquePermissions;

        // Remove Permission
        $scope.remove = function (systemRoleAndEmployee) {
            return reviewUniquePermissionsService.removeUniquePermission($scope.authLogin,
                systemRoleAndEmployee.EmployeeID,
                systemRoleAndEmployee.SystemRoleID)
                .then(function () {
                    systemRoleAndEmployee.IsPendingToRemove = true;
                    systemRoleAndEmployee.IsReviewed = false;
                });
        }

        // Cancel Remove Permission
        $scope.cancelRemove = function (systemRoleAndEmployee) {
            return reviewUniquePermissionsService.cancelRemoveUniquePermission($scope.authLogin,
                systemRoleAndEmployee.EmployeeID,
                systemRoleAndEmployee.SystemRoleID)
                .then(function () {
                    systemRoleAndEmployee.IsPendingToRemove = false;
                    systemRoleAndEmployee.IsToRemove = false;
                    systemRoleAndEmployee.ToRemove = false;
                    systemRoleAndEmployee.IsReviewed = false;
                });
        }

        // Confirm review
        var systemRoleEmployees = _.chain($scope.systemsAndRoles)
            .map('SystemRoles').flatten()
            .map('SystemRoleEmployees').flatten()
            .value();

        $scope.isLastReviewStep = function () {
            var unreviewedSystems = $scope.systemTypesToReview.filter((o) => o.IsReviewed == false);
            var currentSystem = $scope.systemsAndRoles[0];

            // Checking if we are currently at the last step of the review
            if (unreviewedSystems.length == 1 && 
                unreviewedSystems[0].SystemTypeID == currentSystem.SystemTypeID) {
              return true;
            }
            return false;
        }

        $scope.confirmReview = function () {
            $scope.isProcessing = true;

            var systemRoleDecisions = _.map(systemRoleEmployees, _.partialRight(_.pick, ['SystemRoleID', 'EmployeeID', 'IsPendingToRemove', 'IsToRemove']));

            reviewUniquePermissionsService.confirmReview($scope.authLogin, systemRoleDecisions)
                .then(function (response) {
                    if (response.NeedToContinueReview === false) {
                        $state.go('systemOwnerReview.authUser.completed', {
                            authLogin: $scope.authLogin
                        }, { reload: true });
                    }
                    else {
                        $state.go('systemOwnerReview.authUser.reviewUniquePermissions', {
                            authLogin: $scope.authLogin
                        }, { reload: true });
                    }
                });
        }

        $scope.confirmNoSystemsReview = function () {
            $scope.isProcessing = true;
            var sysRoleEmployees = [];

            reviewUniquePermissionsService.confirmReview($scope.authLogin, sysRoleEmployees)
                .then(function (response) {
                    if (response.NeedToContinueReview === false) {
                        $state.go('systemOwnerReview.authUser.completed', {
                            authLogin: $scope.authLogin
                        }, { reload: true });
                    }
                    else {
                        $state.go('systemOwnerReview.authUser.reviewUniquePermissions', {
                            authLogin: $scope.authLogin
                        }, { reload: true });
                    }
                });
        }
    }]);